/* eslint-disable camelcase */
import axios from 'axios';

import { useServicerStore } from '../store';

const CountyService = {
  async getCounties() {
    const response = await axios.get('/county', {
      params: {
        servicer_id: useServicerStore.getState()?.servicerId,
      },
    });

    return response.data;
  },
};

export default CountyService;
